import { dateTrunc, isAfter, isBefore, stringToLocalDate } from "@hex-insights/core";
import { AcademicTerm, StudentAcademicTermEnrollment, StudentNameFragment } from "../../../Utilities";
import * as AcademicTermFormat from "../AcademicTerm";
import * as PersonFormat from "../Person";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentNameFragment, options?: PersonFormat.NameOptions) {
	return PersonFormat.name(instance.person, options);
}

export function status(instance: {
	studentAcademicTermEnrollments: (Pick<StudentAcademicTermEnrollment, "lateStartDate" | "earlyEndDate"> & {
		academicTerm: Pick<AcademicTerm, "startDate" | "endDate">;
	})[];
}) {
	let hasCurrent = false;
	let hasFuture = false;
	let hasPast = false;

	const today = dateTrunc(new Date(), "day");

	for (let i = 0; i < instance.studentAcademicTermEnrollments.length; i++) {
		const enrollment = instance.studentAcademicTermEnrollments[i];
		const term = enrollment.academicTerm;
		const termStatus = AcademicTermFormat.status(term);
		const lateStartDate = enrollment.lateStartDate ? stringToLocalDate(enrollment.lateStartDate, "day") : null;
		const earlyEndDate = enrollment.earlyEndDate ? stringToLocalDate(enrollment.earlyEndDate, "day") : null;

		switch (termStatus) {
			case "Active":
				if (!(lateStartDate === null || isAfter(today, lateStartDate))) {
					hasFuture = true;
					break;
				}
				if (!(earlyEndDate === null || isBefore(today, earlyEndDate))) {
					hasPast = true;
					break;
				}
				hasCurrent = true;
				break;
			case "Upcoming":
				hasFuture = true;
				break;
			case "Past":
				hasPast = true;
				break;
		}
	}

	if (hasCurrent) {
		return "Enrolled";
	}
	if (hasFuture) {
		return "Future";
	}
	if (hasPast) {
		return "Former";
	}
	return "Not Enrolled";
}
